<template>
  <el-dialog
    :title="$t('app.details')"
    :visible.sync="dialogVisible"
    width="800px"
  >
    <el-form label-width="100px" label-position="top" size="small">
      <div class="person-info clearfix">
        <el-col :span="12">
          <el-form-item :label="$t('app.name')">
            <el-input
              style="width: 300px"
              v-model="info.nameEnglish"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('app.studentNumber')">
            <el-input
              style="width: 300px"
              v-model="info.studentNumber"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col>
         <el-col :span="24">
          <el-form-item
            :label="$t('app.currentRoomNumber')"
            v-show="this.isCurrentHostel"
          >
            <el-input
              style="width: 300px"
              v-model="info.currentRoom"
              :disabled="true"
            ></el-input>
          </el-form-item>

          <!--<el-form-item
            :label="$t('app.applyView.roomChoose')"
            v-show="!this.isCurrentHostel"
          >
           <el-radio-group v-model="info.selectedRoomType" :disabled="true">
              <el-radio :label="'1'">{{
                $t("app.roomTypeSelect.noI")
              }}</el-radio
              ><br />
              <el-radio :label="'2'">{{
                $t("app.roomTypeSelect.noII")
              }}</el-radio
              ><br />
              <el-radio :label="'3'">{{
                $t("app.roomTypeSelect.noIII")
              }}</el-radio
              ><br />
              <el-radio :label="'4'">{{
                $t("app.roomTypeSelect.noIIII")
              }}</el-radio>
            </el-radio-group>
          </el-form-item>-->
        </el-col> 
        <el-col>
          <!-- 添加房型選擇 laotang 2023-04-12 -->
          <el-form-item
            :label="$t('app.roomTypeSelect.title')"           
          >
            <el-radio-group v-model="info.selectedRoomType" :disabled="true">
              <el-radio :label="'1'">{{
                $t("app.roomTypeSelect.noI")
              }}</el-radio
              ><br />
              <el-radio :label="'2'">{{
                $t("app.roomTypeSelect.noII")
              }}</el-radio
              ><br />
              <el-radio :label="'3'">{{
                $t("app.roomTypeSelect.noIII")
              }}</el-radio
              ><br />
              <el-radio :label="'4'">{{
                $t("app.roomTypeSelect.noIIII")
              }}</el-radio>
              <br />
              <el-radio :label="'5'">{{
                $t("app.roomTypeSelect.noIIIII")
              }}</el-radio
              ><br />
              <el-radio :label="'6'">{{
                $t("app.roomTypeSelect.noIIIIII")
              }}</el-radio>
            </el-radio-group>
            <!-- <br /> -->
          </el-form-item>
        </el-col>
        <el-form-item
          :label="$t('app.applyOldView.isContinue')"
          v-show="this.isCurrentHostel"
        >
          <el-radio-group v-model="info.isContinueLodge" :disabled="true">
            <el-radio :label="'1'">{{ $t("app.yes") }}</el-radio
            ><br />
            <el-radio :label="'2'">{{ $t("app.applyOldView.noI") }}</el-radio
            ><br />
            <el-radio :label="'3'">{{ $t("app.applyOldView.noII") }}</el-radio>
            <br />
            <el-radio :label="'4'">{{ $t("app.applyOldView.noIII") }}</el-radio>           
          </el-radio-group>
        </el-form-item>
        <el-form-item
          :label="$t('app.applyOldView.isKeep')"
          v-show="this.isCurrentHostel"
        >
          <el-cascader
            :disabled="true"
            v-model="isKeep"
            :options="options"
            :props="{ expandTrigger: 'hover' }"
            style="width: 200px"
          ></el-cascader>
        </el-form-item>
        <el-form-item :label="$t('app.otherNeeds')">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4 }"
            v-model="info.requirement"
            style="width: 600px"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="date"
          :label="$t('app.checkOutDate')"
          v-show="this.isCurrentHostel"
        >
          <el-input
            style="width: 300px"
            v-model="info.checkOutDate"
            :disabled="true"
          ></el-input>
        </el-form-item>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="info" @click="dialogVisible = false">{{
        $t("app.cancel")
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      isCurrentHostel: true,
      info: {},
      options: [
        { value: "1", label: this.$t("app.yes") },
        {
          value: "0",
          label: this.$t("app.no"),
          children: [
            { value: "1", label: this.$t("app.changeRoommates") },
            { value: "2", label: this.$t("app.changeRoomType") },
            { value: "3", label: this.$t("app.changeRoomNumber") }
          ]
        }
      ]
    };
  },
  methods: {
    edit(row) {
      this.dialogVisible = true;
      this.info = JSON.parse(JSON.stringify(row));
       console.log("当前房间: "+ this.info.currentRoom);
      if (this.info.selectedRoomType == null) {
        this.info.selectedRoomType = this.info.roomType;
      }
      if (this.info.currentRoom) {
        this.isCurrentHostel = true;
      } else {
        this.isCurrentHostel = false;
      }
    }
  },
  computed: {
    isKeep() {
      return this.info.isContinueSameRoom
        ? this.info.isContinueSameRoom.split(",")
        : [];
    }
  }
};
</script>
